import { render, staticRenderFns } from "./leagueBar.vue?vue&type=template&id=29757d62&lang=pug&"
import script from "./leagueBar.vue?vue&type=script&lang=js&"
export * from "./leagueBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports